import React from 'react';
import { Button, FeaturedIcon } from '@myhealth-raccoon/components';
import { useLocation } from "react-router-dom";
import { useClinicSelector } from 'src/hooks/useAsyncSelector';
import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';
import { useExit } from 'src/hooks/useExit';

export function ApptTypeRequiresF2F() {
    const location = useLocation();
    const { lastF2FVisitInMonths } = location.state || {}; // Destructure passed state
    const { data: clinic } = useClinicSelector();
    const exit = useExit();

    return (
        <>
            <ContentContainer className='flex-1 lg:flex-none space-y-6 text-center'>
                <FeaturedIcon size="lg" color="error" className="mb-8 mx-auto" />
                <h1 className="text-2xl text-gray-900 font-medium">
                    Appointment type unavailable
                </h1>
                <p>
                    This Appointment Type is only available to patients who have had an in-clinic consultation in the past {lastF2FVisitInMonths} months.
                </p>
                <p>
                    Please book an in-clinic appointment instead, or call our reception
                    {clinic?.phoneNumber ? `on ` : ''} <a className="text-primary" href={`tel:${clinic?.phoneNumber}`}>{clinic?.phoneNumber} </a>
                    for further assistance.
                </p>
            </ContentContainer>
            <StickyBottomBar>
                <Button className="w-full"
                    color="gray"
                    onClick={() => exit()} >
                    Exit
                </Button>
            </StickyBottomBar>
        </>

    );
}